import { Link } from '@flos/react-ui';
import Currency from '../Currency/Currency';
import { useState } from 'react';
import IncludedPriceModal from '../PriceTaxModal/IncludedPriceModal';
import { useHippoText } from '../../hooks/useHippoText';

const TotalPrice = ({
    totalPrice = 0,
    showYearlyPriceField,
    paymentFrequencyPostfix,
    displayTaxesSubtitle = false,
    overrideLabel,
    shouldRenderShoppingBasketDesign = false,
    shouldShowPriceIncludingTaxes = false
}: {
    totalPrice?: number;
    showYearlyPriceField: boolean;
    paymentFrequencyPostfix: string;
    displayTaxesSubtitle?: boolean;
    overrideLabel?: string;
    shouldRenderShoppingBasketDesign?: boolean;
    shouldShowPriceIncludingTaxes?: boolean;
}): React.JSX.Element => {
    const getHippoText = useHippoText();
    const yearlyPrice = totalPrice * 12;
    const [showModal, setShowModal] = useState(false);
    const label = overrideLabel ?? getHippoText('DSS-COMMON-TOTAL-PRICE');
    const taxesSubtitle = getHippoText('DSS-SHOPPING-BASKET-INCLUDED-IN-PRICE');

    return (
        <>
            {shouldRenderShoppingBasketDesign ? (
                <span className="u-flex-box u-flex-box--col u-gap-3">
                    <span className="u-flex-box u-flex-box--center u-flex-box--space-between u-flex-box--no-gap u-flex-box--nowrap">
                        <p className="strong h2@sm u-spacing-stack-bottom-none">{label}</p>
                        <p
                            className="strong h2@sm u-spacing-stack-bottom-none u-text-right"
                            style={{ marginLeft: 'auto' }}
                        >
                            <Currency
                                price={totalPrice}
                                paymentFrequencyPostfix={paymentFrequencyPostfix}
                            />
                        </p>
                    </span>
                    <span className="u-flex-box u-flex-box--center u-flex-box--space-between u-flex-box--no-gap u-flex-box--nowrap">
                        <Link
                            className={
                                'paragraph--small h4@sm u-spacing-stack-none u-color-primary-2-base'
                            }
                            theme="logo"
                            onClick={() => {
                                setShowModal(true);
                            }}
                        >
                            {taxesSubtitle}
                        </Link>
                        {showYearlyPriceField && (
                            <p
                                className="paragraph--small h4@sm u-spacing-stack-bottom-none u-text-right"
                                style={{ marginLeft: 'auto' }}
                            >
                                <Currency
                                    price={yearlyPrice}
                                    paymentFrequencyPostfix={getHippoText('DSS-COMMON-YEAR')}
                                />
                            </p>
                        )}
                    </span>
                </span>
            ) : (
                <div className={'u-spacing-inset-m--stretch-max'}>
                    <div className={'u-flex-box u-flex-box--space-between u-flex-box--nowrap'}>
                        <h6 className={'u-spacing-stack-s'}>
                            {overrideLabel ?? getHippoText('DSS-COMMON-TOTAL-PRICE')}
                        </h6>
                        <h6 className={'u-spacing-stack-s u-text-right'}>
                            <Currency
                                price={totalPrice}
                                paymentFrequencyPostfix={paymentFrequencyPostfix}
                            />
                        </h6>
                    </div>
                    <div className={'u-flex-box u-flex-box--space-between u-flex-box--nowrap'}>
                        {displayTaxesSubtitle ? (
                            <Link
                                className={
                                    'paragraph--small u-spacing-stack-none u-color-primary-2-base'
                                }
                                onClick={() => {
                                    setShowModal(true);
                                }}
                            >
                                {taxesSubtitle}
                            </Link>
                        ) : (
                            <div />
                        )}
                        {showYearlyPriceField && (
                            <p className={'paragraph--small u-spacing-stack-none u-text-right'}>
                                <Currency
                                    price={yearlyPrice}
                                    paymentFrequencyPostfix={getHippoText('DSS-COMMON-YEAR')}
                                />
                            </p>
                        )}
                    </div>
                </div>
            )}
            {showModal && (
                <IncludedPriceModal
                    showModal={showModal}
                    isPaymentYearly={showYearlyPriceField}
                    shouldShowPriceIncludingTaxes={shouldShowPriceIncludingTaxes}
                    closeModal={() => {
                        setShowModal(false);
                    }}
                />
            )}
        </>
    );
};

export default TotalPrice;
